import { defineMessage } from '@lingui/macro'

export const BOOKING_PAGE_HEADING = {
  coding: defineMessage({
    id: 'trialClass.booking.courseHeading.coding',
    message: 'Book a free lesson to enter the magical world of AI & Coding',
  }),
  competition: defineMessage({
    id: 'trialClass.booking.courseHeading.competition',
    message: 'Book a free lesson to win coding competitions & prizes',
  }),
  robotics: defineMessage({
    id: 'trialClass.booking.courseHeading.robotics',
    message:
      'Book a free lesson to get started with the magical world of robotics',
  }),
  algorithms: defineMessage({
    id: 'trialClass.booking.courseHeading.algorithms',
    message:
      'Book a free lesson to get started with Data Structures & Algorithms',
  }),
  mathtrialclass: defineMessage({
    message: 'Book a free lesson to explore the magical world of Math',
  }),
  publicspeakingtrialclass: defineMessage({
    message:
      'Book a free lesson to explore the magical world of Public Speaking',
  }),
  creativewritingstorytellingtrialclass: defineMessage({
    message:
      'Book a free lesson to explore the magical world of Creative Writing',
  }),
}
